<div [formGroup]="apiKeyForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="comment"
    placeholder="Marius´ API-Key"
    label="Kommentar">
  </nx-edit-text-input>
<div>